import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useTranslation } from 'react-i18next';
import { StackBlock, StackInline, TextAlpha, SwatchSelector } from '@yonderland/andes-react';
import { getSwatchUrlByProductCode } from '../../../util/ImageUtil';
import { useDispatch, useSelector } from 'react-redux';
import { useAemConfig } from '@as-react/common-components';
import { productActions } from '../../../redux/product/actions/ProductActions';
import { makeGetAvailableColors, makeGetProductDefaults, makeGetSelectedColorId, } from '../../../redux/product/selectors/ProductSelector';
export const getDiscountIconContent = (productSwatch, productSwatchConfig) => {
    let iconContent = '';
    if (productSwatch.hasDiscount) {
        iconContent = productSwatchConfig.actionLabel;
        if (productSwatch.markdown) {
            iconContent = productSwatchConfig.saleLabel;
        }
    }
    return iconContent;
};
export const generateSwatchFromProductColorVariation = (productColorVariation, selectedColorId, productCode, productImageConfig, swatchInformation) => ({
    id: `${productCode}-${productColorVariation.colorId}`,
    value: productColorVariation.colorId.toString(),
    colourId: productColorVariation.colorId,
    color: productColorVariation.translations.description,
    extendedRange: productColorVariation.webOnly,
    swatch: getSwatchUrlByProductCode(productCode, productColorVariation.swatch, productImageConfig),
    imageUrl: getSwatchUrlByProductCode(productCode, productColorVariation.swatch, productImageConfig),
    selected: selectedColorId === productColorVariation.colorId,
    hasDiscount: Boolean(productColorVariation.hasDiscount),
    hasPermanentDiscount: Boolean(productColorVariation.markdown),
    outOfStock: productColorVariation.availability === 0,
    textOverlay: getDiscountIconContent(productColorVariation, swatchInformation),
    title: productColorVariation.translations.description,
    size: 'sm',
    lazyLoad: true,
});
export const ColorSwatchesAlpha = ({ enableShopTheLook }) => {
    const { feature_toggles: { categorized_product_features }, pageInfo: { isPDPPage }, productImageConfig, productSwatchConfig, } = useAemConfig();
    const dispatch = useDispatch();
    const colors = useSelector(makeGetAvailableColors());
    const productCode = useSelector(makeGetProductDefaults()).productCode;
    const selectedColorId = useSelector(makeGetSelectedColorId());
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const [description, setDescription] = useState();
    const swatches = colors.map((productColor) => generateSwatchFromProductColorVariation(productColor, selectedColorId, productCode, productImageConfig.cdnDomains, productSwatchConfig));
    useEffect(() => {
        const selectedColorVariation = colors.find((colorVariation) => colorVariation.colorId === selectedColorId);
        if (!selectedColorVariation) {
            return;
        }
        setDescription(selectedColorVariation.translations.description);
    }, [swatches, selectedColorId]);
    const setProductColor = (colourId) => {
        dispatch(productActions.createSetColorAction(colourId));
        if (isPDPPage && categorized_product_features) {
            dispatch(productActions.createGetTechnicalCategories(colourId));
        }
        if (enableShopTheLook) {
            dispatch(productActions.createGetLinkedProducts(colourId));
        }
    };
    const handleChange = (colourId) => {
        if (Number(colourId) !== selectedColorId) {
            setProductColor(Number(colourId));
        }
    };
    return (_jsxs(StackBlock, { gap: "1", children: [_jsxs(StackInline, { gap: "1", children: [_jsxs(TextAlpha, { children: [t('product:pdp.color'), ": "] }), _jsx(TextAlpha, { strong: true, color: "emphasised", testId: "color_name", children: description })] }), swatches && swatches.length > 1 && (_jsx(SwatchSelector, { name: `color_swatch_${productCode}`, testId: "swatch-selector", defaultValue: String(selectedColorId), onChange: handleChange, swatches: swatches }))] }));
};
